import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import {useLogto} from '@logto/react';

const ProtectedRoute = ({ element: Component }) => {
    const { isAuthenticated, isLoading } = useLogto();
    // Track if we've ever completed initial auth check to prevent
    // unmounting children during token refresh cycles
    const [hasCompletedInitialLoad, setHasCompletedInitialLoad] = useState(false);

    useEffect(() => {
        if (!isLoading && !hasCompletedInitialLoad) {
            setHasCompletedInitialLoad(true);
        }
    }, [isLoading, hasCompletedInitialLoad]);

    // Only show loading on initial load, not on subsequent token refreshes
    if (isLoading && !hasCompletedInitialLoad) {
        return <div>Loading session...</div>;
    }

    return isAuthenticated ? (
        <Component />
    ) : (
        <Navigate to="/landing" />
    );
};

export default ProtectedRoute;
